import React from 'react';
import { v3GeneralLedgerSettingsPage } from '@/utils/translations';

const CONTAINER = 'p-8';
const TITLE = 'text-2xl font-bold text-emerge-navy mb-4';
const SUBTITLE = 'text-aux-gray-2';

const EmergeGeneralLedgerSettings = () => (
  <div className={CONTAINER}>
    <h1 className={TITLE}>{v3GeneralLedgerSettingsPage.title}</h1>
    <p className={SUBTITLE}>{v3GeneralLedgerSettingsPage.comingSoon}</p>
  </div>
);

export default EmergeGeneralLedgerSettings;
